module.exports = __webpack_public_path__ + "staticcomp/img/top.c1dac02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1/top.jpg
// module id = l7qE
// module chunks = 39